module.exports = __webpack_public_path__ + "static/31-thumb-6f46d54aa70bf8d9795c6c8e1e8ef99d.jpg";